import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './theme/shared/shared.module';

import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgbButtonsModule, NgbDropdownModule, NgbNavModule, NgbTabsetModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ElbuildCoreComponentsModule, ElbuildUiComponentslibModule } from 'elbuild-ui-componentslib';
import { AuthConfig, ElbuildUiLibModule } from 'elbuild-ui-lib-core';
import { MatteiniUiLibModule } from 'matteini-ui-lib';
import { ToastrModule } from 'ngx-toastr';
import 'reflect-metadata';
import { CoreModule } from './@core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BackofficeAuthModule } from './backoffice-auth/backoffice-auth.module';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { NavLeftComponent } from './theme/layout/admin/nav-bar/nav-left/nav-left.component';
import { NavSearchComponent } from './theme/layout/admin/nav-bar/nav-left/nav-search/nav-search.component';
import { ChatMsgComponent } from './theme/layout/admin/nav-bar/nav-right/chat-msg/chat-msg.component';
import { ChatUserListComponent } from './theme/layout/admin/nav-bar/nav-right/chat-user-list/chat-user-list.component';
import { FriendComponent } from './theme/layout/admin/nav-bar/nav-right/chat-user-list/friend/friend.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import * as moment from 'moment';
   import { QuillModule } from 'ngx-quill';





const authConfig: AuthConfig = {
	cookieprefix: 'matteini',
	loginpage: 'signin',
	usertable: 'user',
	enablefeatures: true
};

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
	bootstrap: [AppComponent],
	declarations: [
		AppComponent,
		AdminComponent,
		AuthComponent,
		NavigationComponent,
		NavContentComponent,
		NavGroupComponent,
		NavCollapseComponent,
		NavItemComponent,
		NavBarComponent,
		NavLeftComponent,
		NavSearchComponent,
		NavRightComponent,
		ChatUserListComponent,
		FriendComponent,
		ChatMsgComponent,
		ConfigurationComponent,
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		SharedModule,
		BrowserAnimationsModule,
		SharedModule,
		NgbDropdownModule,
		NgbTooltipModule,
		NgbButtonsModule,
		NgbTabsetModule,
		FormsModule,

		QuillModule.forRoot(),
		CoreModule.forRoot(),
		MatteiniUiLibModule.forRoot(),
		ElbuildUiLibModule.forRoot(authConfig),
		ElbuildUiComponentslibModule.forRoot(),
		BackofficeAuthModule,
		ElbuildCoreComponentsModule,
		ToastrModule.forRoot({
			preventDuplicates: true,
		}),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient],
			},
			defaultLanguage: 'it',
		}),
		CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
	],
	providers: [NavigationItem],
})
export class AppModule { }
